<script setup lang="ts">
/**
 * UI-kit component
 * Category: Loaders
 * Name: LoaderOverlay
 */
import type { LoaderOverlayProps } from '@UI/Loaders/LoaderOverlay/types/interfaces'

import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'

defineOptions({
  name: 'LoaderOverlay',
})

const {
  size = 'lg',
  glass = true,
} = defineProps<LoaderOverlayProps>()
</script>

<template>
  <div :class="['loader-overlay', { 'loader-overlay--glass': glass }]">
    <LoaderBlockDomain :size="size" />
  </div>
</template>

<style lang="scss" scoped src="../styles/_loader-overlay.scss" />
